module.exports = __webpack_public_path__ + "media/images/shop-dashboard-billing-icon-4b81a26a28f8cc504d4bbaf871a04381.png";